var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.st2{fill:#777777;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    className: "st1",
    width: 801,
    height: 799
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_468_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_469_",
    className: "st2",
    d: "M592,459.7c-1.6-0.7-59.9-29.5-70.2-33.2c-4.2-1.5-8.8-3-13.6-3c-7.9,0-14.5,3.9-19.6,11.6 c-5.8,8.7-23.5,29.3-28.9,35.4c-0.7,0.8-1.7,1.8-2.3,1.8c-0.5,0-9.5-3.7-12.3-4.9c-62.6-27.2-110.1-92.5-116.6-103.6 c-0.9-1.6-1-2.3-1-2.3c0.2-0.8,2.3-2.9,3.4-4c3.2-3.1,6.6-7.3,9.9-11.3c1.6-1.9,3.2-3.8,4.7-5.6c4.8-5.6,7-10,9.5-15l1.3-2.6 c6.1-12.1,0.9-22.3-0.8-25.6c-1.4-2.8-26-62.2-28.6-68.4c-6.3-15.1-14.6-22.1-26.2-22.1c-1.1,0,0,0-4.5,0.2 c-5.5,0.2-35.3,4.2-48.5,12.5c-14,8.8-37.6,36.9-37.6,86.4c0,44.5,28.2,86.5,40.4,102.5c0.3,0.4,0.9,1.2,1.7,2.4 c46.4,67.8,104.3,118,163,141.5c56.5,22.6,83.2,25.2,98.4,25.2c0,0,0,0,0,0c6.4,0,11.5-0.5,16-0.9l2.9-0.3 c19.5-1.7,62.4-23.9,72.1-51.1c7.7-21.3,9.7-44.7,4.6-53.1C605.6,466.3,599.6,463.4,592,459.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_470_",
    className: "st2",
    d: "M407.1,0C190.4,0,14.2,174.9,14.2,390c0,69.6,18.6,137.6,53.9,197.2L0.6,786.3 c-1.3,3.7-0.3,7.8,2.4,10.6c2,2,4.7,3.1,7.4,3.1c1.1,0,2.1-0.2,3.1-0.5l207.6-66c56.8,30.4,121,46.4,186,46.4 C623.7,779.9,800,605,800,390C800,174.9,623.7,0,407.1,0z M407.1,698.7c-61.1,0-120.4-17.7-171.3-51.1c-1.7-1.1-3.7-1.7-5.7-1.7 c-1.1,0-2.1,0.2-3.1,0.5l-104,33.1l33.6-99c1.1-3.2,0.5-6.7-1.5-9.5c-38.8-53-59.3-115.5-59.3-181 c0-170.2,139.6-308.7,311.2-308.7c171.6,0,311.2,138.5,311.2,308.7C718.3,560.2,578.7,698.7,407.1,698.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/whatsApp.a503efa31295f2fad1cd658e60349a79.svg";
export { ForwardRef as ReactComponent };